import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const MultiSelectTailwindThemes = {
  multiselect: {
    root: ({ props, state }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'cursor-pointer inline-flex relative w-full select-none outline-transparent',
        'bg-white border border-fletchers-gray-100 transition-colors duration-200 ease-in-out rounded-sm',
        'hover:border-fletchers-gray-200',
        {
          'border-fletchers-gray-200': state.overlayVisible || props.value,
          'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
          'outline-2 outline-offset-2 outline-fletchers-green-500': state.focused && !state.overlayVisible,
        },
      ),
    }),
    labelContainer: 'overflow-hidden flex flex-auto cursor-pointer',
    label: ({ props, state }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'cursor-pointer flex flex-auto overflow-hidden overflow-ellipsis whitespace-nowrap relative',
        'bg-transparent border-0 text-fletchers-gray-200',
        'px-2.25 py-1.25 transition duration-200 bg-transparent rounded appearance-none font-sans text-xs/5',
        {
          'text-black': state.overlayVisible || props.value,
          'block pr-7': props.showClear && props.value,
        },
      ),
    }),
    token: {
      className: classNames(
        'px-2 py-1 mr-2 bg-gray-300 text-fletchers-gray-200 rounded-full',
        'cursor-default inline-flex items-center',
      ),
    },
    removeTokenIcon: 'ml-2',
    trigger: {
      className: classNames(
        'flex items-center justify-center shrink-0',
        'bg-transparent text-fletchers-gray-200 w-8 rounded-tr-sm rounded-br-sm',
      ),
    },
    panel: {
      className: classNames('mt-1.25 bg-white text-fletchers-gray-200 border-0 rounded-sm shadow-lg'),
    },
    header: {
      className: classNames(
        'py-1.5 pr-2 pl-3 text-fletchers-gray-200 bg-fletchers-gray-50 rounded-t-sm',
        'flex items-center justify-between',
      ),
    },
    headerCheckboxContainer: {
      className: classNames(
        'flex items-center rounded-t-sm px-3 py-1.5 bg-fletchers-gray-50',
        '[&>[data-pc-name="checkbox"]]:mr-2',
      ),
    },
    headerCheckbox: {
      root: {
        className: classNames(
          'flex items-center justify-center',
          'text-fletchers-gray-200 rounded-sm transition-colors duration-200',
        ),
      },
    },
    headerSelectAllLabel: 'font-sans text-xs/5 font-normal text-black',
    headerCheckboxIcon: 'size-4 transition-all duration-200 text-white text-base',
    closeButton: {
      className: classNames(
        'flex items-center justify-center overflow-hidden relative cursor-pointer',
        'size-7 text-black border-0 bg-transparent rounded-full transition duration-200 ease-in-out mr-2 last:mr-0',
        'hover:border-transparent hover:bg-fletchers-green-50',
        'outline-transparent focus-visible:outline-2 focus-visible:outline-fletchers-green-500',
      ),
    },
    closeIcon: 'size-3 inline-block',
    wrapper: {
      className: classNames(
        'max-h-[200px] overflow-auto',
        'bg-white text-fletchers-gray-200 border-0 rounded-b-sm shadow-lg',
      ),
    },
    list: 'list-none',
    item: ({ context }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'flex items-center',
        'cursor-pointer overflow-hidden relative whitespace-nowrap',
        'font-normal font-sans text-xs/5 text-black',
        'm-0 px-3 py-1.5 border-0 transition-shadow duration-200 rounded-none',
        'hover:bg-fletchers-green-50 focus:outline-none',
        {
          'bg-fletchers-green-50': context.focused && !context.selected,
          'bg-fletchers-green-100 hover:bg-fletchers-green-100': context.selected,
          'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
        },
      ),
    }),
    checkboxContainer: {
      className: classNames('inline-flex cursor-pointer select-none items-center relative', 'mr-2'),
    },
    checkbox: {
      className: classNames(
        'flex items-center justify-center',
        'text-fletchers-gray-200 rounded-sm transition-colors duration-200',
      ),
    },
    checkboxIcon: 'size-6 transition-all duration-200 text-white text-base',
    itemGroup: {
      className: classNames('m-0 p-3 text-fletchers-gray-200 bg-white font-bold', 'cursor-auto'),
    },
    filtercontainer: 'relative',
    filterinput: {
      className: classNames(
        'pr-7 -mr-7',
        'w-full',
        'font-sans text-sm text-fletchers-gray-200 bg-white py-3 px-3 border border-fletchers-gray-200 transition duration-200 rounded-sm appearance-none',
        'hover:border-fletchers-gray-200 focus:border-fletchers-gray-200',
      ),
    },
    filtericon: '-mt-2 absolute top-1/2',
    clearicon: {
      className: classNames(
        'text-fletchers-gray-200 right-9 -mt-2 absolute top-1/2 rounded outline-transparent',
        'focus:outline-2 focus:outline-fletchers-green-500',
      ),
    },
    transition: {
      timeout: 150,
      classNames: {
        enter: 'opacity-0 scale-75',
        enterActive: 'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
        exit: 'opacity-100',
        exitActive: '!opacity-0 transition-opacity duration-150 ease-linear',
      },
    },
  },
};
